"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const use_immer_1 = require("use-immer");
const components_1 = require("../../../../components");
const ModalUnFollow_1 = __importDefault(require("../../../../components/modal/ModalUnFollow"));
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../../navigators/Routes"));
const rootNavigation_1 = require("../../../../navigators/rootNavigation");
const Basic_1 = __importDefault(require("../../../../networking/apis/Basic"));
const User_1 = __importDefault(require("../../../../networking/apis/User"));
const helpler_1 = require("../../../../utils/helpler");
const scale_1 = require("../../../../utils/scale");
const styles_1 = __importDefault(require("../styles"));
const AccountItem_1 = __importDefault(require("./AccountItem"));
const slice_1 = __importDefault(require("../../../../app-reduxs/app/slice"));
const messages_1 = require("../../../../constants/messages");
const react_redux_1 = require("react-redux");
var ActionType;
(function (ActionType) {
    ActionType[ActionType["UNBLOCK"] = 0] = "UNBLOCK";
    ActionType[ActionType["BLOCK"] = 1] = "BLOCK";
})(ActionType || (ActionType = {}));
const keyExtractor = (item, _) => `${item.user_id}`;
const AccountBlock = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [selectedUser, setSelectedUser] = (0, react_1.useState)();
    const [userList, updateUserList] = (0, use_immer_1.useImmer)([]);
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const refCurrentPage = (0, react_1.useRef)(1);
    const refIsNoMore = (0, react_1.useRef)(false);
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const modalVisible = !!selectedUser;
    (0, react_1.useEffect)(() => {
        fetchUserData();
    }, []);
    // fetching data
    const fetchUserData = async () => {
        if (refIsNoMore.current || isLoading)
            return;
        try {
            setLoading(true);
            const response = await User_1.default.getBlockUserList({ page: refCurrentPage.current });
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.last_page) {
                refIsNoMore.current = true;
            }
            if (response?.data?.data?.length > 0) {
                updateUserList((draft) => {
                    draft.push(...response.data.data);
                });
            }
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    };
    const handleActionButton = async (userId, index) => {
        const userSelected = userList[index];
        if (refIsCallingAPI.current || !userSelected)
            return;
        refIsCallingAPI.current = true;
        try {
            if (userSelected.is_blocked) {
                await Basic_1.default.unblockUser(userId);
                updateUserList((draft) => {
                    draft[index].is_blocked = ActionType.UNBLOCK;
                });
            }
            else {
                await Basic_1.default.blockUser(userId);
                updateUserList((draft) => {
                    draft[index].is_blocked = ActionType.BLOCK;
                });
            }
        }
        catch (error) {
            dispatch(slice_1.default.actions.showToast(messages_1.MESSAGES.ERROR_MESSAGE_DEFAULT));
            console.log(error);
        }
        finally {
            refIsCallingAPI.current = false;
        }
    };
    const getBlockHeader = (0, react_1.useCallback)(() => (react_1.default.createElement(react_native_1.View, { style: styles_1.default.listHeader },
        react_1.default.createElement(CustomText_1.default, { style: styles_1.default.listHeaderLabel }, "\u30D6\u30ED\u30C3\u30AF\u3057\u3066\u3044\u308B\u30A2\u30AB\u30A6\u30F3\u30C8\u306E\u30EA\u30B9\u30C8\u3067\u3059\u3002\u3053\u306E\u30EA\u30B9\u30C8\u3067\u8FFD\u52A0\u3084\u524A\u9664\u3092\u884C\u3048\u307E\u3059\u3002"),
        react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.listHeaderButton, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.ACCOUNT_BLOCK_OVERVIEW) },
            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.listHeaderButtonLabel }, "\u8A73\u7D30\u306F\u3053\u3061\u3089")))), []);
    const getBlockEmpty = () => (react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.emptyText }, "\u30D6\u30ED\u30C3\u30AF\u3057\u305F\u30E6\u30FC\u30B6\u30FC\u306F\u3044\u307E\u305B\u3093"));
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.body },
        react_1.default.createElement(react_native_1.FlatList, { data: userList, keyExtractor: keyExtractor, renderItem: ({ item, index }) => (react_1.default.createElement(AccountItem_1.default, { idx: index, userInfo: item, tabIndex: 0, onSubmit: handleActionButton })), contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(100),
            }, scrollEventThrottle: 400, ListHeaderComponent: getBlockHeader, ListEmptyComponent: getBlockEmpty, onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    fetchUserData();
                }
            }, ListFooterComponent: isLoading ? react_1.default.createElement(components_1.LoadingView, { style: styles_1.default.loading }) : null }),
        react_1.default.createElement(ModalUnFollow_1.default, { visible: modalVisible, onClose: () => setSelectedUser(undefined), modalPosition: modalPosition, hashTag: selectedUser?.nickname, 
            // openModalNoti={handleUnfollowUser}
            openModalNoti: () => { } })));
};
exports.default = AccountBlock;
